import persistedState from './persisted-state';
import uiUpdateMobile from './ui-update-mobile';

export default [
	persistedState,
	uiUpdateMobile,
];
